import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { GetForecastForReceiptSummaryData } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage';

/**
 * 受領用内示ごとの回収状況を取得するUseCase
 */
export class GetForecastForReceiptSummaryUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 受領用内示ごとの回収状況を取得する
   * @param receivedYear - 内示受領年
   * @param receivedMonth - 内示受領月
   * @param userIds - フィルタする担当者IDリスト（任意）
   */
  public async Execute(
    receivedYear: number,
    receivedMonth: number,
    userIds?: string[]
  ): Promise<INetworkResult<GetForecastForReceiptSummaryData[], Error>> {
    try {
      const userIdsParam = userIds && userIds.length > 0 ? userIds.join(',') : undefined;
      const result = await this.repository.getForecastForReceiptSummary(receivedYear, receivedMonth, userIdsParam);

      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('受領用内示の回収状況の取得に失敗しました'),
        },
      };
    }
  }
}
